import { Grid } from '@mui/material';
import { color, COLOR_VARIANTS, Divider } from '@tajawal/ct-web-design-system';
import Styled from './LegSkeleton.styled';

function LegSkeleton(): JSX.Element {
  return (
    <Grid item xs={12} container display="flex" direction="column" justifyContent="center" alignItems="center">
      <Grid item xs={12} container direction="row" justifyContent="end" alignItems="end">
        <Grid item xs={2}>
          <Styled.Skeleton variant="rectangular" width={72} height={16} />
        </Grid>
        <Grid item xs={8}>
          <Styled.StopsWrapper>
            <Styled.Dot />
            <Divider style={{ flexGrow: 1 }} className="divider" variant="solid" />
            <Styled.FlightsIcon width="16" height="16" color={color(COLOR_VARIANTS.GAINSBORO)} />
          </Styled.StopsWrapper>
        </Grid>
        <Grid item xs={2} display="flex" justifyContent="flex-end">
          <Styled.Skeleton variant="rectangular" width={72} height={16} />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        container
        marginY={1}
        marginX={0}
        direction="row"
        justifyContent="space-between"
        alignItems="end"
      >
        <Grid display="flex" justifyContent="flex-start" item xs={4}>
          <Styled.Skeleton variant="rectangular" width={54} height={16} />
        </Grid>
        <Grid display="flex" justifyContent="center" item xs={3}>
          <Styled.Skeleton variant="rectangular" width={54} height={16} />
        </Grid>
        <Grid display="flex" justifyContent="flex-end" alignSelf="flex-end" item xs={4}>
          <Styled.Skeleton variant="rectangular" width={54} height={16} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default LegSkeleton;
